import { Button, Dropdown } from 'antd';
import type { VFC } from 'react';
import { Icon } from '@/components/icon';

export interface ActionTableButtonsProps {
  onEdit: () => void;
  onDelete: () => void;
  hasSnapshot: boolean;
}

export const ActionTableButtons: VFC<ActionTableButtonsProps> = ({ hasSnapshot, onEdit, onDelete }) => {
  return hasSnapshot ? (
    <Button block disabled icon={<Icon iconString="lock" />} />
  ) : (
    <Dropdown.Button
      buttonsRender={([, rightButton]) => [
        <Button key={`${Math.random()}`} block onClick={onEdit}>
          Edit
        </Button>,
        rightButton,
      ]}
      menu={{
        items: [{ key: '1', icon: <Icon iconString="delete" />, label: 'Delete', danger: true }],
        onClick: onDelete,
      }}
    />
  );
};
